// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import Categories__Admin__Administrators__AllObjectAccessController from "./categories/admin/administrators/all_object_access_controller"
application.register("categories--admin--administrators--all-object-access", Categories__Admin__Administrators__AllObjectAccessController)

import Categories__Admin__Administrators__TieredCampaignsController from "./categories/admin/administrators/tiered_campaigns_controller"
application.register("categories--admin--administrators--tiered-campaigns", Categories__Admin__Administrators__TieredCampaignsController)

import Categories__Admin__Campaigns__Matchallenges__PaginatedCompetingDesignationsController from "./categories/admin/campaigns/matchallenges/paginated_competing_designations_controller"
application.register("categories--admin--campaigns--matchallenges--paginated-competing-designations", Categories__Admin__Campaigns__Matchallenges__PaginatedCompetingDesignationsController)

import Categories__Admin__Campaigns__Matchallenges__WtaSearchInputController from "./categories/admin/campaigns/matchallenges/wta_search_input_controller"
application.register("categories--admin--campaigns--matchallenges--wta-search-input", Categories__Admin__Campaigns__Matchallenges__WtaSearchInputController)

import Categories__Admin__Events__Edit__CustomFieldFormPanelController from "./categories/admin/events/edit/custom_field_form_panel_controller"
application.register("categories--admin--events--edit--custom-field-form-panel", Categories__Admin__Events__Edit__CustomFieldFormPanelController)

import Categories__Admin__Events__Edit__PromoCodesController from "./categories/admin/events/edit/promo_codes_controller"
application.register("categories--admin--events--edit--promo-codes", Categories__Admin__Events__Edit__PromoCodesController)

import Categories__Admin__Events__PrintButtonController from "./categories/admin/events/print_button_controller"
application.register("categories--admin--events--print-button", Categories__Admin__Events__PrintButtonController)

import Categories__Admin__GiftOfficer__AiProfileController from "./categories/admin/gift_officer/ai_profile_controller"
application.register("categories--admin--gift-officer--ai-profile", Categories__Admin__GiftOfficer__AiProfileController)

import Categories__Admin__ComposerConversionController from "./categories/admin/composer_conversion_controller"
application.register("categories--admin--composer-conversion", Categories__Admin__ComposerConversionController)

import Categories__Admin__Pages__CampaignsTieredListController from "./categories/admin/pages/campaigns_tiered_list_controller"
application.register("categories--admin--pages--campaigns-tiered-list", Categories__Admin__Pages__CampaignsTieredListController)

import Categories__Admin__ReviewGifts__ConstituentIdRadioController from "./categories/admin/review_gifts/constituent_id_radio_controller"
application.register("categories--admin--review-gifts--constituent-id-radio", Categories__Admin__ReviewGifts__ConstituentIdRadioController)

import Categories__Admin__ReviewGifts__ErrorModalController from "./categories/admin/review_gifts/error_modal_controller"
application.register("categories--admin--review-gifts--error-modal", Categories__Admin__ReviewGifts__ErrorModalController)

import Categories__Admin__ReviewGifts__ErrorPanelController from "./categories/admin/review_gifts/error_panel_controller"
application.register("categories--admin--review-gifts--error-panel", Categories__Admin__ReviewGifts__ErrorPanelController)

import Categories__Admin__ReviewGifts__RecurringGiftRadioController from "./categories/admin/review_gifts/recurring_gift_radio_controller"
application.register("categories--admin--review-gifts--recurring-gift-radio", Categories__Admin__ReviewGifts__RecurringGiftRadioController)

import Categories__Admin__Settings__FormFields__AddFieldPanelController from "./categories/admin/settings/form_fields/add_field_panel_controller"
application.register("categories--admin--settings--form-fields--add-field-panel", Categories__Admin__Settings__FormFields__AddFieldPanelController)

import Categories__Admin__Settings__FormFields__EditFieldPanelController from "./categories/admin/settings/form_fields/edit_field_panel_controller"
application.register("categories--admin--settings--form-fields--edit-field-panel", Categories__Admin__Settings__FormFields__EditFieldPanelController)

import Categories__Admin__Settings__FormFields__RemoveFieldPanelController from "./categories/admin/settings/form_fields/remove_field_panel_controller"
application.register("categories--admin--settings--form-fields--remove-field-panel", Categories__Admin__Settings__FormFields__RemoveFieldPanelController)

import Categories__Admin__Settings__FormFields__ViewFormsPanelController from "./categories/admin/settings/form_fields/view_forms_panel_controller"
application.register("categories--admin--settings--form-fields--view-forms-panel", Categories__Admin__Settings__FormFields__ViewFormsPanelController)

import Categories__Admin__Settings__FormFieldsController from "./categories/admin/settings/form_fields_controller"
application.register("categories--admin--settings--form-fields", Categories__Admin__Settings__FormFieldsController)

import Fluid__AccordionController from "./fluid/accordion_controller"
application.register("fluid--accordion", Fluid__AccordionController)

import Fluid__HtmlTooltipController from "./fluid/html_tooltip_controller"
application.register("fluid--html-tooltip", Fluid__HtmlTooltipController)

import Fluid__ListboxController from "./fluid/listbox_controller"
application.register("fluid--listbox", Fluid__ListboxController)

import Fluid__ModalController from "./fluid/modal_controller"
application.register("fluid--modal", Fluid__ModalController)

import Fluid__PanelController from "./fluid/panel_controller"
application.register("fluid--panel", Fluid__PanelController)

import Fluid__RadioToggleController from "./fluid/radio_toggle_controller"
application.register("fluid--radio-toggle", Fluid__RadioToggleController)

import Fluid__ToggleRadioController from "./fluid/toggle_radio_controller"
application.register("fluid--toggle-radio", Fluid__ToggleRadioController)

import Fluid__TooltipController from "./fluid/tooltip_controller"
application.register("fluid--tooltip", Fluid__TooltipController)

import FluidTableController from "./fluid_table_controller"
application.register("fluid-table", FluidTableController)

import ImageController from "./image_controller"
application.register("image", ImageController)

import Sortable from "@stimulus-components/sortable"
application.register("sortable", Sortable)

import MasonryController from "./masonry_controller"
application.register("masonry", MasonryController)

import MembershipLaunchActionController from "./membership_launch_action_controller"
application.register("membership-launch-action", MembershipLaunchActionController)

import Projects__Campaigns__MatchallengeController from "./projects/campaigns/matchallenge_controller"
application.register("projects--campaigns--matchallenge", Projects__Campaigns__MatchallengeController)

import DebugStimulusController from "./debug_stimulus_controller"
application.register("debug-stimulus", DebugStimulusController)

import SmoothScrollController from "./smooth_scroll_controller"
application.register("smooth--scroll", SmoothScrollController)

import QrScannerController from "./qr_scanner_controller"
application.register("qr-scanner", QrScannerController)
